(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDialogController', NormaDialogController);

    NormaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Norma', 'IntrumentoRelacionado', 'Documento', 'OrganoRelevante', 'PalabraClave', 'TipoOrdenamiento', 'Materia'];

    function NormaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Norma, IntrumentoRelacionado, Documento, OrganoRelevante, PalabraClave, TipoOrdenamiento, Materia) {
        var vm = this;

        vm.norma = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.intrumentorelacionados = IntrumentoRelacionado.query();
        vm.documentos = Documento.query();
        vm.organorelevantes = OrganoRelevante.query();
        vm.normas = Norma.query();
        vm.palabraclaves = PalabraClave.query();
        vm.tipoordenamientos = TipoOrdenamiento.query();
        vm.materias = Materia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.norma.id !== null) {
                Norma.update(vm.norma, onSaveSuccess, onSaveError);
            } else {
                Norma.save(vm.norma, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:normaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaEmision = false;
        vm.datePickerOpenStatus.fechaPublicacion = false;
        vm.datePickerOpenStatus.fechaSJFYG = false;
        vm.datePickerOpenStatus.fechaSJFGaceta = false;
        vm.datePickerOpenStatus.fechaDOF = false;

        vm.setAbstractoConcreto = function ($file, norma) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        norma.abstractoConcreto = base64Data;
                        norma.abstractoConcretoContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
